import React, { useEffect, useState } from 'react'
import { Container } from './styled'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import InternalHeader from '../../general/internalHeader/view'
import CommunityListItem from '../communityListItem/view'
import { getCommunitiesForMember, searchPublicCommunities } from 'api'
import { Grid, Typography, Box } from '@mui/material'
import NoResultsPlaceholder from 'components/organisms/noResultsPlaceholder/view'
import CommunitySlider from 'components/organisms/communitySlider/view';
import { useNavigate } from 'react-router'
import noAvatar from '../../../../assets/images/no-avatar.png'
import { getAvatarUrl, getBackgroundUrl } from '../../../../api/utils'
import coworking from 'assets/images/coworking.jpg'
import { useProfile } from 'context';


const CommunityHome = () => {

  const { t } = useTranslation()
  const params = useParams()
  const { profile } = useProfile()
  const { slug } = params
  const [communities, setCommunities] = useState([])
  const [searchResults, setSearchResults] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  function getCommunityInfo() {
    getCommunitiesForMember().then(r => {
      setCommunities(r.communities || [])
    })
      .catch(console.error)
  }

  function searchCommunities(search = '') {
    if (!search.trim()) {
      setIsSearching(false)
      setSearchResults([])
      return
    }
    
    setLoading(true)
    setIsSearching(true)
    searchPublicCommunities({ search }).then(r => {
      setSearchResults(r.communities || r.groups || [])
    })
    .catch(console.error)
    .finally(() => setLoading(false))
  }

  function handleSearchChange(event) {
    const value = event.target.value
    setSearchTerm(value)
  }

  function headerActionMethod() {
    // Can be used for creating new community or other actions
  }

  function navigateCommunity(item) {
    // Handle both string slugs and objects with group.slug or slug
    const slug = typeof item === 'string' ? item : (item?.group?.slug || item?.slug)
    navigate(`/community/${slug}`)
  }

  useEffect(() => {
    getCommunityInfo()
  }, [])

  useEffect(() => {
    // Debounce search
    const timer = setTimeout(() => {
      searchCommunities(searchTerm)
    }, 300)
    return () => clearTimeout(timer)
  }, [searchTerm])



  const avatar = getAvatarUrl(profile, noAvatar)
  const background = getBackgroundUrl(profile, coworking)
  
  const displayCommunities = isSearching ? searchResults : communities
  const title = isSearching ? 'Search Results' : 'Your communities'
  const subtitle = isSearching ? `${searchResults.length} ${searchResults.length === 1 ? 'community' : 'communities'} found` : ''

  return (
    <Container>
      {/* Global toolbar */}
      {/* Community header */}
      <InternalHeader 
        title={title} 
        subtitle={subtitle} 
        avatar={avatar} 
        background={background}
        showSearch={true}
        searchValue={searchTerm}
        onSearchChange={handleSearchChange}
        searchPlaceholder="Search communities..."
      />

      <Box sx={{ maxWidth: 1200, margin: '0 auto', padding: 3 }}>
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {loading ? (
            <Grid item xs={12}>
              <Typography align="center" sx={{ py: 4 }}>
                Loading...
              </Typography>
            </Grid>
          ) : displayCommunities?.length === 0 ? (
            <Grid item xs={12} md={12} sx={{ paddingTop: 5 }}>
              <NoResultsPlaceholder 
                firstSentence={isSearching ? 'No communities found' : t('No communities found')} 
                lastSentence={isSearching ? 'Try a different search term' : t('Browse our communities and join them!')} 
              />
            </Grid>
          ) : (
            displayCommunities.map((item, index) => (
              <Grid item xs={6} sm={4} md={3} key={index}>
                <CommunityListItem 
                  group={item} 
                  selectCommunity={() => navigateCommunity(item)} 
                />
              </Grid>
            ))
          )}
        </Grid>
        
        {!isSearching && (
          <Grid sx={{ mt: 4 }}>
            <CommunitySlider 
              navigateCommunity={(item) => navigateCommunity(item)} 
              existingCommunities={communities.filter(c => c.group)} 
              showMore={false}
            />
          </Grid>
        )}
      </Box>
    </Container>
  )
}

CommunityHome.propTypes = {}

export default CommunityHome
